import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { ascending } from 'd3-array';
function isSegmentIntersect(_ref, _ref2) {
  var _ref3 = _slicedToArray(_ref, 2),
    a = _ref3[0],
    b = _ref3[1];
  var _ref4 = _slicedToArray(_ref2, 2),
    c = _ref4[0],
    d = _ref4[1];
  return d > a && b > c;
}
function useMap() {
  var map = new Map();
  var get = function get(key) {
    return map.get(key);
  };
  var set = function set(key, value) {
    return map.set(key, value);
  };
  return [get, set];
}
function getBoundsWithoutConnector(shape) {
  var node = shape.cloneNode(true);
  var connectorShape = node.getElementById('connector');
  connectorShape && node.removeChild(connectorShape);
  var _node$getRenderBounds = node.getRenderBounds(),
    min = _node$getRenderBounds.min,
    max = _node$getRenderBounds.max;
  node.destroy();
  return {
    min: min,
    max: max
  };
}
/**
 * An iterative dodge method avoids label overlap. (n * log(n))
 */
export var OverlapDodgeY = function OverlapDodgeY(options) {
  var _options$maxIteration = options.maxIterations,
    maxIterations = _options$maxIteration === void 0 ? 10 : _options$maxIteration,
    _options$maxError = options.maxError,
    maxError = _options$maxError === void 0 ? 0.1 : _options$maxError,
    _options$padding = options.padding,
    padding = _options$padding === void 0 ? 1 : _options$padding;
  return function (labels) {
    var n = labels.length;
    if (n <= 1) return labels;
    // Index y, x0, x, height, by label.
    var _useMap = useMap(),
      _useMap2 = _slicedToArray(_useMap, 2),
      y0 = _useMap2[0],
      setY0 = _useMap2[1];
    var _useMap3 = useMap(),
      _useMap4 = _slicedToArray(_useMap3, 2),
      y = _useMap4[0],
      setY = _useMap4[1];
    var _useMap5 = useMap(),
      _useMap6 = _slicedToArray(_useMap5, 2),
      h = _useMap6[0],
      setH = _useMap6[1];
    var _useMap7 = useMap(),
      _useMap8 = _slicedToArray(_useMap7, 2),
      xx = _useMap8[0],
      setXX = _useMap8[1];
    var _iterator = _createForOfIteratorHelper(labels),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var label = _step.value;
        var _getBoundsWithoutConn = getBoundsWithoutConnector(label),
          min = _getBoundsWithoutConn.min,
          max = _getBoundsWithoutConn.max;
        var _min = _slicedToArray(min, 2),
          x0 = _min[0],
          _y2 = _min[1];
        var _max = _slicedToArray(max, 2),
          x1 = _max[0],
          _y3 = _max[1];
        setY0(label, _y2);
        setY(label, _y2);
        setH(label, _y3 - _y2);
        setXX(label, [x0, x1]);
      }
      // Offsets position Y.
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    for (var iter = 0; iter < maxIterations; iter++) {
      labels.sort(function (a, b) {
        return ascending(y(a), y(b));
      });
      var error = 0;
      for (var i = 0; i < n - 1; i++) {
        var l0 = labels[i];
        var j = i + 1;
        var l1 = void 0;
        // Find the next label overlapping with the current label in x direction.
        while ((l1 = labels[j]) && !isSegmentIntersect(xx(l0), xx(l1))) j += 1;
        if (l1) {
          var _y = y(l0);
          var h0 = h(l0);
          var y1 = y(l1);
          var delta = y1 - (_y + h0);
          if (delta < padding) {
            var newDelta = (padding - delta) / 2;
            error = Math.max(error, newDelta);
            setY(l0, _y - newDelta);
            setY(l1, y1 + newDelta);
          }
        }
      }
      if (error < maxError) break;
    }
    var _iterator2 = _createForOfIteratorHelper(labels),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _label = _step2.value;
        _label.style.y += y(_label) - y0(_label);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return labels;
  };
};